(function(angular){
	'use strict';

	angular
		.module('campaignsModule', [
			'apiModule',
			'campaignCtaModule',
			'coreModule',
			'countUpModule',
			'futureEarningsChartModule',
			'historicalPerformanceChartModule',
			'hypotheticalPerformanceModule',
			'incomeReitHistoricalDividendsChartModule',
			'ngCookies',
			'reitElementListingModule',
			'yieldComparisonChartModule'
		])
		.value('globalConfig', globalConfig);
})(window.angular);